import React from "react";
import style from "./styles.module.scss";
import SkeletonLoader from "../../../components/skeleton-loader";

function OrganizationDetailsLoader() {
  return (
    <>
      <div className={style.skeletonHeader}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className={style.skeletonHeaderLeftTop}>
            <SkeletonLoader variant="circular" width="24px" height="24px" />
            <SkeletonLoader variant="text" width="102px" height="24px" />
          </div>
          <div className={style.skeletonMenu}>
            <SkeletonLoader
              variant="circular"
              width="24px"
              height="24px"
              style={{ marginRight: "16px" }}
            />
          </div>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <div className={style.skeletonHeaderLeft}>
            <div className={style.skeletonHeaderLeftTop}>
              <SkeletonLoader
                variant="rectangular"
                width="48px"
                height="48px"
              />
              <div className={style.skeletonHeaderLeftBottom}>
                <SkeletonLoader
                  variant="text"
                  width="150px"
                  height="28px"
                  className={style.skeletonTitle}
                />
                <div>
                  <SkeletonLoader
                    variant="circular"
                    width="12px"
                    height="12px"
                  />
                  <SkeletonLoader
                    variant="text"
                    width="100px"
                    height="20px"
                    className={style.skeletonButton}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className={style.skeletonActions}>
            <SkeletonLoader
              variant="rectangular"
              style={{ borderRadius: "8px", marginRight: "16px" }}
              width="24px"
              height="24px"
            />
          </div>
        </div>
      </div>

      <div className={style.skeletonContent}>
        <SkeletonLoader
          variant="text"
          width="90px"
          height="16px"
          className={style.skeletonTextLine}
        />
        <SkeletonLoader variant="text" width="50px" height="16px" />
        <div className={style.skeletonContentItems}>
          {[1, 2, 3].map((column) => (
            <div key={`skeleton-data-item-${column}`}>
              <SkeletonLoader variant="circular" width="16px" height="16px" />
              <SkeletonLoader
                variant="text"
                width={column === 3 ? "250px" : "100px"}
                height="22px"
              />
            </div>
          ))}
        </div>
      </div>

      <div className={style.skeletonTabs}>
        {[1, 2, 3, 4, 5, 6].map((tab) => (
          <SkeletonLoader
            key={`tab-${tab}`}
            variant="rectangular"
            width="90px"
            height="24px"
            className={style.skeletonTab}
          />
        ))}
      </div>

      <SkeletonLoader
        variant="rectangular"
        width="100%"
        height="72px"
        style={{
          borderRadius: "4px",
        }}
      />

      <div>
        <SkeletonLoader
          variant="rectangular"
          width="250px"
          height="32px"
          style={{ borderRadius: "8px" }}
        />

        <div className={style.skeletonContentItemsBottom}>
          {Array.from({ length: 12 }).map((_, column) => (
            <div key={`skeleton-file-loader-${column}`}>
              <SkeletonLoader
                variant="rectangular"
                width="100%"
                height="49px"
              />
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default OrganizationDetailsLoader;
